module.exports = __webpack_public_path__ + "img/パスポート.b9a489f8.png";